var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<span ng-bind-html=\"vm.$sce.trustAsHtml(vm.model | spaced)\" class=\"spaced-wrapper\"></span>");;return buf.join("");
}